<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Cadastro de tentativas de contato"
    >
        <Form
            :solicitacao="solicitacao"
            @save="handleSave"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                v-if="showHistorico"
                :disabled="!!loading"
                @click="$refs.ModalHistorico.open(solicitacao)"
                color="primary"
            >
                Histórico
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

        <ModalHistorico
            v-if="showHistorico"
            readonly
            ref="ModalHistorico"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: {
        Form,
        ModalHistorico: () => import('@/components/regulacao/fila/components/tentativa-contato/Modal')
    },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleSave() {

            this.$emit('save')

            this.$refs.Modal.hide()
        },
    },
    props: {
        solicitacao: { type: Object, required: true },
        showHistorico: { type: Boolean, default: false },
    },
}
</script>